import DefaultAvatar from 'components/common/DefaultAvatar';
import React from 'react';

import FutureAppointmentList from './FutureAppointmentList';
import NotMailedAppointmentList from './NotMailedAppointmentList';
import TodayAppointmentList from './TodayAppointmentList';

export const getActiveAppointmentTabs = (
  todayApptsCount = 0,
  futureApptsCount = 0,
  notMailedApptsCount = 0,
): Array<{ title: any; component: any }> => [
  {
    title: (
      <div className='flex items-center'>
        <div className='mr-2'>Today</div>
        {todayApptsCount !== 0 && todayApptsCount && <DefaultAvatar bgColor='red'>{todayApptsCount}</DefaultAvatar>}
      </div>
    ),
    component: TodayAppointmentList,
  },
  {
    title: (
      <div className='flex items-center'>
        <div className='mr-2'>Future</div>
        {futureApptsCount !== 0 && futureApptsCount && <DefaultAvatar bgColor='red'>{futureApptsCount}</DefaultAvatar>}
      </div>
    ),
    component: FutureAppointmentList,
  },
  {
    title: (
      <div className='flex items-center'>
        <div className='mr-2'>Not Mailed</div>
        {notMailedApptsCount !== 0 && notMailedApptsCount && (
          <DefaultAvatar bgColor='red'>{notMailedApptsCount}</DefaultAvatar>
        )}
      </div>
    ),
    component: NotMailedAppointmentList,
  },
];
